module.exports = __webpack_public_path__ + "assets/adpoly-it-desktops-screens-bulk-upload-template.14cb4369.xlsx";